var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7502 0.833496H3.75016C2.8335 0.833496 2.0835 1.5835 2.0835 2.50016V14.1668H3.75016V2.50016H13.7502V0.833496ZM16.2502 4.16683H7.0835C6.16683 4.16683 5.41683 4.91683 5.41683 5.8335V17.5002C5.41683 18.4168 6.16683 19.1668 7.0835 19.1668H16.2502C17.1668 19.1668 17.9168 18.4168 17.9168 17.5002V5.8335C17.9168 4.91683 17.1668 4.16683 16.2502 4.16683ZM16.2502 17.5002H7.0835V5.8335H16.2502V17.5002Z",
    fill: "#4D4634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/ContentCopy.045b2f17902abeb5cae6c53e11e7ce6c.svg";
export { ForwardRef as ReactComponent };